<template>
  <div
    class="c-bitts-dropdown-option"
    :class="classes"
    role="button"
    :tabindex="disabled ? -1 : 0"
  >
    <div class="flex items-center gap-8 w-full">
      <slot name="prefix">
        <FontAwesomeIcon
          v-if="icon"
          :icon="icon"
          :class="iconColor"
          :style="{ width: '16px', height: '16px' }"
        />
      </slot>

      <span class="option-label truncate flex-1 text-left">
        <slot>{{ label }}</slot>
      </span>

      <slot name="suffix">
        <FontAwesomeIcon
          v-if="showCheckmark && active"
          :icon="['fak', 'check']"
          class="text-secondary-accent"
          :style="{ width: '16px', height: '16px' }"
        />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BittsIcon } from '../types';

const {
  active,
  disabled,
  icon,
  label,
  variant = 'default',
  showCheckmark = false,
} = defineProps<{
  icon?: BittsIcon;
  label?: string;
  active?: boolean;
  variant?: 'default' | 'upsell';
  disabled?: boolean;
  showCheckmark?: boolean;
}>();

const iconColor = computed(() =>
  active && variant === 'upsell'
    ? 'text-secondary-accent'
    : 'text-neutral-accent',
);

const classes = computed(() => [
  variant,
  {
    active,
    disabled,
  },
]);
</script>

<style scoped lang="pcss">
@reference "../../../../apps/crossbeam-app/src/css/theme.css";

.c-bitts-dropdown-option {
  @apply px-8 py-4 rounded-6 cursor-pointer text-neutral-text-strong transition-colors max-w-300 min-w-260;

  &.disabled {
    @apply cursor-not-allowed opacity-50;
  }

  /* Variant: Default */
  &.default.active {
    @apply bg-neutral-background;
  }

  &.default:hover:not(.active):not(.disabled) {
    @apply bg-neutral-background-weak;
  }

  /* Variant: Upsell */
  &.upsell.active {
    @apply bg-secondary-background-weak;
  }

  &.upsell:hover:not(.active):not(.disabled) {
    @apply bg-secondary-background-weak;
  }
}
</style>
